


// import { useState, useEffect, useContext } from "react";
// import MainLayouts from "../../Layout/MainLayouts";
// import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
// import { ReactComponent as Download } from "bootstrap-icons/icons/download.svg";
// import { ReactComponent as ArrowClockwise } from "bootstrap-icons/icons/arrow-clockwise.svg";
// import { ReactComponent as ShieldCheck } from "bootstrap-icons/icons/shield-check.svg";
// import { ReactComponent as ShieldExclamation } from "bootstrap-icons/icons/shield-exclamation.svg";
// import { ReactComponent as QuestionCircle } from "bootstrap-icons/icons/question-circle.svg";
// import { ReactComponent as People } from "bootstrap-icons/icons/people.svg";
// import Spinner from "../spinner/Spinner";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import ApiServices from "../../api/ApiServices";
// import { toast } from "react-toastify";
// import DataTable from "react-data-table-component";
// import CustomStyles from "../../components/utils/CustomStyles";
// import { handleError } from "../../components/utils/AuthenticationCheck";
// import { downloadCSVFromApi } from "../../components/utils/DownlaodCSVFromApi";
// import { AuthContext } from "../../AuthProvider/AuthProvider";

// const GetSecurityQuestionStat = () => {
//     const [stats, setStats] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [loadingCSV, setLoadingCSV] = useState(false);
//     const [filterText, setFilterText] = useState("");
//     const [filterLoading, setFilterLoading] = useState(false);
//     const [clearFilterLoading, setClearFilterLoading] = useState(false);
//     const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
//     const { permissions } = useContext(AuthContext);

//     const [filters, setFilters] = useState({
//         per_page: 20,
//         page: 1,
//         start_date: "",
//         end_date: "",
//         search: "",
//     });

//     const [pagination, setPagination] = useState({
//         total: 0,
//         currentPage: 1,
//         perPage: 20,
//     });

//     const navigate = useNavigate();

//     const fetchSecurityQuestionStats = async (filterPayload = filters) => {
//         setLoading(true);
//         try {
//             const authData = JSON.parse(localStorage.getItem("auth"));
//             const token = authData?.token;
//             if (!token) throw new Error("No access token found.");

//             const response = await axios.get(ApiServices.getSecurityQuestionStats, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     "Content-Type": "application/json",
//                 },
//                 params: filterPayload,
//                 withCredentials: true,
//             });

//             const { status, message, data } = response.data;

//             if (status === 200 && data) {
//                 setStats(data);
//                 setPagination({
//                     total: data.question_usage_stats?.length || 0,
//                     currentPage: 1,
//                     perPage: filters.per_page,
//                 });
//                  toast.success(message, { toastId: "security-stats-fetch-success" });
//             } else {
//                 handleError({ response: { status, data: { message } } }, navigate);
//             }
//         } catch (error) {
//             handleError(error, navigate);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchSecurityQuestionStats();
//     }, []);

//     // Check if both dates are selected for CSV download
//     const areDatesSelected = filters.start_date && filters.end_date;

//     // Handle CSV Download - Server-side filtered by date
//     const handleDownloadCSV = async () => {
//         if (!areDatesSelected) {
//             toast.error("Please select both start and end dates to download CSV");
//             return;
//         }

//         // Validate date range
//         const startDate = new Date(filters.start_date);
//         const endDate = new Date(filters.end_date);

//         if (startDate > endDate) {
//             toast.error("Start date must be before end date");
//             return;
//         }

//         // Limit date range to a year
//         const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
//         if (daysDiff > 365) {
//             toast.error("Date range cannot exceed 1 year");
//             return;
//         }

//         setLoadingCSV(true);

//         try {
//             const authData = JSON.parse(localStorage.getItem("auth"));
//             const token = authData?.token;

//             if (!token) {
//                 toast.error("No access token found");
//                 return;
//             }

//             // Prepare download payload 
//             const downloadPayload = {
//                 start_date: filters.start_date,
//                 end_date: filters.end_date,
//                 search: filterText || undefined,
//                 download: 1,
//             };

//             // Create filename with date range
//             const startDateFormatted = filters.start_date.replace(/-/g, '_');
//             const endDateFormatted = filters.end_date.replace(/-/g, '_');
//             const filename = `security_questions_stats_${startDateFormatted}_to_${endDateFormatted}.csv`;

//             // Call the download function
//             await downloadCSVFromApi(
//                 ApiServices.getSecurityQuestionStats,
//                 downloadPayload,
//                 token,
//                 {
//                     filename: filename,
//                     columnsToRemove: [], // Add sensitive columns to exclude 
//                     maxRows: 50000
//                 }
//             );

//             toast.success("CSV download started successfully!");

//         } catch (error) {
//             console.error("Download error:", error);
//             handleError(error, navigate);
//             // Additional download-specific error messages
//             if (error.message && error.message.includes("CSV")) {
//                 toast.error("Failed to process CSV file");
//             } else if (error.message && error.message.includes("network")) {
//                 toast.error("Network error during download");
//             } else {
//                 toast.error("Failed to download CSV");
//             }
//         } finally {
//             setLoadingCSV(false);
//         }
//     };

//     const isAnyFilterFilled = () => {
//         return Object.values(filters).some(
//             (value) => value !== "" && value !== null && value !== 20 && value !== 1
//         );
//     };

//     const handleClearFilters = async () => {
//         const defaultFilters = {
//             per_page: 20,
//             page: 1,
//             start_date: "",
//             end_date: "",
//             search: "",
//         };

//         setFilters(defaultFilters);
//         setFilterText("");
//         setClearFilterLoading(true);
//         await fetchSecurityQuestionStats(defaultFilters);
//         setClearFilterLoading(false);
//     };

//     const handleFilterClick = async () => {
//         if (!isAnyFilterFilled()) return;
//         setFilterLoading(true);
//         await fetchSecurityQuestionStats(filters);
//         setFilterLoading(false);
//     };

//     // Handle pagination
//     const handlePageChange = (page) => {
//         const newFilters = {
//             ...filters,
//             page: page
//         };
//         setFilters(newFilters);
//         fetchSecurityQuestionStats(newFilters);
//     };

//     // Handle per page change
//     const handlePerRowsChange = async (newPerPage, page) => {
//         const newFilters = {
//             ...filters,
//             page: page,
//             per_page: newPerPage
//         };
//         setFilters(newFilters);
//         await fetchSecurityQuestionStats(newFilters);
//     };

//     // Calculate percentages
//     const calculatePercentage = (part, total) => {
//         if (total === 0) return 0;
//         return ((part / total) * 100).toFixed(1);
//     };

//     // Filter data based on search text
//     const filteredQuestions = stats?.question_usage_stats?.filter((item) => {
//         if (!filterText) return true;

//         return Object.values(item).some(
//             (value) =>
//                 typeof value === "string" &&
//                 value.toLowerCase().includes(filterText.toLowerCase())
//         );
//     }) || [];

//     const columns = [
//         {
//             name: "Question ID",
//             selector: (row) => row.question_id || "N/A",
//             sortable: true,
//             width: "120px",
//         },
//         {
//             name: "Question Text",
//             selector: (row) => row.question_text || "N/A",
//             sortable: true,
//             width: "400px",
//             cell: (row) => (
//                 <div className="truncate max-w-xs" title={row.question_text}>
//                     {row.question_text}
//                 </div>
//             ),
//         },
//         {
//             name: "Users Answered",
//             selector: (row) => row.users_answered || 0,
//             sortable: true,
//             width: "150px",
//             cell: (row) => (
//                 <div className="flex items-center">
//                     <span className="font-semibold mr-2">{row.users_answered}</span>
//                     <div className="w-24 bg-gray-200 rounded-full h-2">
//                         <div
//                             className="bg-darkGreen3 h-2 rounded-full"
//                             style={{
//                                 width: `${calculatePercentage(row.users_answered, stats?.total_users || 1)}%`
//                             }}
//                         ></div>
//                     </div>
//                     <span className="text-xs text-gray-500 ml-2">
//                         {calculatePercentage(row.users_answered, stats?.total_users || 1)}%
//                     </span>
//                 </div>
//             ),
//         },
//         {
//             name: "Popularity",
//             selector: (row) => row.users_answered,
//             sortable: true,
//             width: "150px",
//             cell: (row) => {
//                 const percentage = calculatePercentage(row.users_answered, stats?.total_users || 1);
//                 let badgeClass = "bg-gray-100 text-gray-800";

//                 if (percentage > 50) {
//                     badgeClass = "bg-green-100 text-green-800";
//                 } else if (percentage > 20) {
//                     badgeClass = "bg-blue-100 text-blue-800";
//                 } else if (percentage > 0) {
//                     badgeClass = "bg-yellow-100 text-yellow-800";
//                 }

//                 return (
//                     <span className={`px-2 py-1 rounded text-xs font-medium ${badgeClass}`}>
//                         {percentage > 50 ? "High" : percentage > 20 ? "Medium" : percentage > 0 ? "Low" : "Unused"}
//                     </span>
//                 );
//             },
//         },
//     ];

//     const ExpandableComponent = ({ data }) => (
//         <div className="p-4 bg-gray-50 rounded-lg">
//             <div className="grid grid-cols-2 gap-4">
//                 <div>
//                     <h5 className="font-semibold text-gray-700 mb-2">Question Details</h5>
//                     <p className="text-sm text-gray-600">{data.question_text}</p>
//                 </div>
//                 <div>
//                     <h5 className="font-semibold text-gray-700 mb-2">Usage Statistics</h5>
//                     <div className="space-y-1">
//                         <p className="text-sm">
//                             <span className="font-medium">Answered by:</span> {data.users_answered} users
//                         </p>
//                         <p className="text-sm">
//                             <span className="font-medium">Percentage:</span> {calculatePercentage(data.users_answered, stats?.total_users || 1)}% of total users
//                         </p>
//                         {stats?.total_users && (
//                             <p className="text-sm">
//                                 <span className="font-medium">Remaining:</span> {stats.total_users - data.users_answered} users haven't answered
//                             </p>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );

//     return (
//         <MainLayouts>
//             <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
//                 {/* Breadcrumb */}
//                 <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
//                     <nav className="bg-gray-200 py-0 px-4 rounded-lg">
//                         <ol className="list-none p-0 inline-flex mb-2">
//                             <li className="flex items-center">
//                                 <p className="text-darkGreen3 pr-2">Security</p>
//                                 <ChevronRightIcon />
//                             </li>
//                             <li className="flex items-center">
//                                 <p className="text-darkGreen3 pr-2">Questions</p>
//                                 <ChevronRightIcon />
//                             </li>
//                             <li className="flex items-center">
//                                 <p className="text-orange1">Statistics</p>
//                             </li>
//                         </ol>
//                     </nav>
//                 </section>

//                 {/* Statistics Cards */}
//                 {stats && (
//                     <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
//                         <div className="p-4 bg-blue-50 rounded-lg shadow-sm border border-blue-100">
//                             <div className="flex items-center">
//                                 <People className="w-8 h-8 text-blue-600 mr-3" />
//                                 <div>
//                                     <div className="font-bold text-2xl">{stats.total_users || 0}</div>
//                                     <div className="text-sm text-blue-700">Total Users</div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="p-4 bg-green-50 rounded-lg shadow-sm border border-green-100">
//                             <div className="flex items-center">
//                                 <ShieldCheck className="w-8 h-8 text-green-600 mr-3" />
//                                 <div>
//                                     <div className="font-bold text-2xl">{stats.users_with_security_questions || 0}</div>
//                                     <div className="text-sm text-green-700">With Security Questions</div>
//                                     <div className="text-xs text-gray-500">
//                                         {calculatePercentage(stats.users_with_security_questions, stats.total_users)}% of total
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="p-4 bg-orange-50 rounded-lg shadow-sm border border-orange-100">
//                             <div className="flex items-center">
//                                 <ShieldExclamation className="w-8 h-8 text-orange-600 mr-3" />
//                                 <div>
//                                     <div className="font-bold text-2xl">{stats.users_without_security_questions || 0}</div>
//                                     <div className="text-sm text-orange-700">Without Security Questions</div>
//                                     <div className="text-xs text-gray-500">
//                                         {calculatePercentage(stats.users_without_security_questions, stats.total_users)}% of total
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="p-4 bg-purple-50 rounded-lg shadow-sm border border-purple-100">
//                             <div className="flex items-center">
//                                 <QuestionCircle className="w-8 h-8 text-purple-600 mr-3" />
//                                 <div>
//                                     <div className="font-bold text-2xl">{stats.total_questions_answered || 0}</div>
//                                     <div className="text-sm text-purple-700">Total Questions Answered</div>
//                                     <div className="text-xs text-gray-500">
//                                         Avg: {(stats.total_questions_answered / (stats.users_with_security_questions || 1)).toFixed(1)} per user
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 {/* Filter Controls with Download Button */}
//                 <div className="pb-4 bg-white dark:bg-gray-900 mb-4">
//                     <div className="flex flex-wrap gap-3 mb-4">
//                         {/* Search Input */}
//                         <input
//                             type="text"
//                             placeholder="Search questions..."
//                             value={filterText}
//                             onChange={(e) => setFilterText(e.target.value)}
//                             className="border rounded px-3 py-2 border-lGrey flex-grow"
//                         />

//                         {/* Start & End Dates */}
//                         <input
//                             type="date"
//                             value={filters.start_date}
//                             onChange={(e) =>
//                                 setFilters({ ...filters, start_date: e.target.value })
//                             }
//                             className="border rounded px-3 py-2 border-lGrey"
//                             max={filters.end_date || undefined}
//                         />
//                         <input
//                             type="date"
//                             value={filters.end_date}
//                             onChange={(e) =>
//                                 setFilters({ ...filters, end_date: e.target.value })
//                             }
//                             className="border rounded px-3 py-2 border-lGrey"
//                             min={filters.start_date || undefined}
//                         />

//                         {/* Filter Button */}
//                         <button
//                             onClick={handleFilterClick}
//                             className="bg-darkGreen3 text-lGrey px-4 py-2 rounded disabled:opacity-50 disabled:cursor-not-allowed"
//                             disabled={!isAnyFilterFilled() || filterLoading}
//                         >
//                             {filterLoading ? "Filtering..." : "Filter"}
//                         </button>

//                         {/* Clear Filters Button */}
//                         {isAnyFilterFilled() && (
//                             <button
//                                 onClick={handleClearFilters}
//                                 className="bg-black1 text-lGrey px-4 py-2 rounded hover:bg-orange1 transition-colors"
//                                 disabled={clearFilterLoading}
//                             >
//                                 {clearFilterLoading ? "Clearing..." : "Clear Filters"}
//                             </button>
//                         )}

//                         {/* Download CSV Button */}
//                         <button
//                             onClick={handleDownloadCSV}
//                             className={`inline-flex justify-center items-center gap-x-2 px-4 py-2 rounded-md text-sm font-semibold transition-colors duration-200 ${areDatesSelected
//                                 ? "bg-orange1 text-lGrey3 hover:bg-orange-600 cursor-pointer"
//                                 : "bg-gray-300 text-gray-500 cursor-not-allowed"
//                                 }`}
//                             disabled={!areDatesSelected || loadingCSV}
//                             title={!areDatesSelected ? "Select start and end dates to enable download" : "Download CSV for selected date range"}
//                         >
//                             {loadingCSV ? (
//                                 <>
//                                     <ArrowClockwise className="w-4 h-4 text-white animate-spin" />
//                                     Downloading...
//                                 </>
//                             ) : (
//                                 <>
//                                     <Download className="w-4 h-4" />
//                                     Download CSV
//                                 </>
//                             )}
//                         </button>
//                     </div>

//                     {/* Help text showing filtered results */}
//                     {areDatesSelected && filteredQuestions.length > 0 && (
//                         <div className="mt-2">
//                             <p className="text-sm text-gray-600">
//                                 Showing {filteredQuestions.length} questions from {filters.start_date} to {filters.end_date}
//                             </p>
//                         </div>
//                     )}
//                     {areDatesSelected && filteredQuestions.length === 0 && (
//                         <div className="mt-2">
//                             <p className="text-sm text-orange1">
//                                 No questions found for the selected date range ({filters.start_date} to {filters.end_date})
//                             </p>
//                         </div>
//                     )}
//                     {!areDatesSelected && (
//                         <div className="mt-2">
//                             <p className="text-xs text-gray-500">
//                                 Select start and end dates to filter records and enable CSV download
//                             </p>
//                         </div>
//                     )}
//                 </div>

//                 {/* Data Table */}
//                 {loading ? (
//                     <Spinner />
//                 ) : stats && filteredQuestions.length > 0 ? (
//                     <DataTable
//                         columns={columns}
//                         data={filteredQuestions}
//                         pagination
//                         paginationServer
//                         paginationTotalRows={pagination.total}
//                         paginationDefaultPage={pagination.currentPage}
//                         paginationPerPage={pagination.perPage}
//                         paginationResetDefaultPage={resetPaginationToggle}
//                         onChangePage={handlePageChange}
//                         onChangeRowsPerPage={handlePerRowsChange}
//                         highlightOnHover
//                         striped
//                         customStyles={CustomStyles}
//                         noDataComponent={
//                             <div className="py-8 text-center text-gray-500">
//                                 No security question statistics found
//                             </div>
//                         }
//                         expandableRows
//                         expandableRowsComponent={ExpandableComponent}
//                     />
//                 ) : (
//                     <div className="py-8 text-center text-gray-500">
//                         {filterText ? "No questions match your search" : "No security question statistics available"}
//                     </div>
//                 )}
//             </div>
//         </MainLayouts>
//     );
// };

// export default GetSecurityQuestionStat;




import { useState } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import Spinner from "../spinner/Spinner";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import CustomStyles from "../../components/utils/CustomStyles";
import { useSecurityQuestionStats } from "../../hooks/useAppData";

const GetSecurityQuestionStat = () => {
    const [filterText, setFilterText] = useState("");

    const navigate = useNavigate();

    const { data: statsResponse, isLoading: loading } = useSecurityQuestionStats();
    const stats = statsResponse?.data || null;
    const pagination = {
        total: stats?.question_usage_stats?.length || 0,
        currentPage: 1,
        perPage: 20,
    };

    // Calculate percentages
    const calculatePercentage = (part, total) => {
        if (total === 0) return 0;
        return ((part / total) * 100).toFixed(1);
    };

    // Filter data based on search text
    const filteredQuestions = stats?.question_usage_stats?.filter((item) => {
        if (!filterText) return true;

        return Object.values(item).some(
            (value) =>
                typeof value === "string" &&
                value.toLowerCase().includes(filterText.toLowerCase())
        );
    }) || [];

    const columns = [

        {
            name: "Question Text",
            selector: (row) => row.question_text || "N/A",
            sortable: true,
            width: "400px",
            cell: (row) => (
                <div className="truncate max-w-xs" title={row.question_text}>
                    {row.question_text}
                </div>
            ),
        },
        {
            name: "Users Answered",
            selector: (row) => row.users_answered || 0,
            sortable: true,
            width: "150px",
            cell: (row) => (
                <div className="flex items-center">
                    <span className="font-semibold mr-2">{row.users_answered}</span>

                </div>
            ),
        },
        {
            name: "Percentage",
            selector: (row) => calculatePercentage(row.users_answered, stats?.total_users || 1),
            sortable: true,
            width: "150px",
            cell: (row) => {
                const percentage = calculatePercentage(row.users_answered, stats?.total_users || 1);
                return (
                    <div className="flex items-center">
                        <span className="font-medium">{percentage}%</span>
                    </div>
                );
            },
        },

    ];

    // const ExpandableComponent = ({ data }) => (
    //     <div className="p-4 bg-gray-50 rounded-lg">
    //         <div className="grid grid-cols-2 gap-4">
    //             <div>
    //                 <h5 className="font-semibold text-gray-700 mb-2">Question Details</h5>
    //                 <p className="text-sm text-gray-600">{data.question_text}</p>
    //             </div>
    //             <div>
    //                 <h5 className="font-semibold text-gray-700 mb-2">Usage Statistics</h5>
    //                 <div className="space-y-1">
    //                     <p className="text-sm">
    //                         <span className="font-medium">Answered by:</span> {data.users_answered} users
    //                     </p>
    //                     <p className="text-sm">
    //                         <span className="font-medium">Percentage:</span> {calculatePercentage(data.users_answered, stats?.total_users || 1)}% of total users
    //                     </p>
    //                     {stats?.total_users && (
    //                         <p className="text-sm">
    //                             <span className="font-medium">Remaining:</span> {stats.total_users - data.users_answered} users haven't answered
    //                         </p>
    //                     )}
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    // );

    return (
        <MainLayouts>
            <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
                {/* Breadcrumb */}
                <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
                    <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                        <ol className="list-none p-0 inline-flex mb-2">
                            <li className="flex items-center">
                                <p className="text-darkGreen3 pr-2">Security</p>
                                <ChevronRightIcon />
                            </li>
                            <li className="flex items-center">
                                <p className="text-darkGreen3 pr-2">Questions</p>
                                <ChevronRightIcon />
                            </li>
                            <li className="flex items-center">
                                <p className="text-orange1">Statistics</p>
                            </li>
                        </ol>
                    </nav>
                </section>

                {/* Statistics Cards */}
                {stats && (
                    <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
                        <div className="p-4 bg-blue-50 rounded-lg shadow-sm border border-blue-100">
                            <div className="flex items-center">
                                <div>
                                    <div className="font-bold text-2xl">{stats.total_users || 0}</div>
                                    <div className="text-sm text-blue-700">Total Users</div>
                                </div>
                            </div>
                        </div>

                        <div className="p-4 bg-green-50 rounded-lg shadow-sm border border-green-100">
                            <div className="flex items-center">
                                <div>
                                    <div className="font-bold text-2xl">{stats.users_with_security_questions || 0}</div>
                                    <div className="text-sm text-green-700">With Security Questions</div>
                                    <div className="text-xs text-gray-500">
                                        {calculatePercentage(stats.users_with_security_questions, stats.total_users)}% of total
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="p-4 bg-orange-50 rounded-lg shadow-sm border border-orange-100">
                            <div className="flex items-center">
                                <div>
                                    <div className="font-bold text-2xl">{stats.users_without_security_questions || 0}</div>
                                    <div className="text-sm text-orange-700">Without Security Questions</div>
                                    <div className="text-xs text-gray-500">
                                        {calculatePercentage(stats.users_without_security_questions, stats.total_users)}% of total
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="p-4 bg-purple-50 rounded-lg shadow-sm border border-purple-100">
                            <div className="flex items-center">
                                <div>
                                    <div className="font-bold text-2xl">{stats.total_questions_answered || 0}</div>
                                    <div className="text-sm text-purple-700">Total Questions Answered</div>
                                    <div className="text-xs text-gray-500">
                                        Avg: {(stats.total_questions_answered / (stats.users_with_security_questions || 1)).toFixed(1)} per user
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Search Filter */}
                <div className="pb-4 bg-white mb-4">
                    <div className="flex flex-wrap gap-3 mb-4">
                        <input
                            type="text"
                            placeholder="Search questions..."
                            value={filterText}
                            onChange={(e) => setFilterText(e.target.value)}
                            className="border rounded px-3 py-2 border-lGrey flex-grow max-w-md"
                        />
                    </div>
                </div>

                {/* Data Table */}
                {loading ? (
                    <Spinner />
                ) : stats && filteredQuestions.length > 0 ? (
                    <DataTable
                        columns={columns}
                        data={filteredQuestions}
                        pagination
                        paginationTotalRows={pagination.total}
                        paginationDefaultPage={pagination.currentPage}
                        paginationPerPage={pagination.perPage}
                        highlightOnHover
                        striped
                        customStyles={CustomStyles}
                        noDataComponent={
                            <div className="py-8 text-center text-gray-500">
                                No security question statistics found
                            </div>
                        }
                    // expandableRows
                    // expandableRowsComponent={ExpandableComponent}
                    />
                ) : (
                    <div className="py-8 text-center text-gray-500">
                        {filterText ? "No questions match your search" : "No security question statistics available"}
                    </div>
                )}
            </div>
        </MainLayouts>
    );
};

export default GetSecurityQuestionStat;